// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { headerStyles } from "@conklin/Overrides/Widgets/MyListsDetails/MyListsDetailsHeader";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { displayFlexOnPrint, iconLinkCommonStyles, xScreen } from "@conklin/XDL/Utilities";
import Plus from "@insite/mobius/Icons/Plus";
import { css } from "styled-components";

headerStyles.infoGridItem = {
    width: 12,
    css: css`
        align-items: flex-end;
        flex-wrap: wrap;
        column-gap: 30px;
        ${displayFlexOnPrint}
        @media print {
            justify-content: flex-start;
        }
        ${xScreen("lte", "sm")} {
            align-items: flex-start;
            flex-direction: column;
        }
    `,
};
headerStyles.sharingStatus = {
    statusText: {
        size: 12,
    },
    privateTooltip: {
        cssOverrides: {
            tooltipContainer: css`
                margin-left: -200px;
                &::after {
                    margin-left: 85px;
                }
                ${xScreen("lte", "sm")} {
                    margin-left: 0;
                }
            `,
        },
    },
};
headerStyles.totalText = {
    weight: fontConfig.weight.bold,
};

headerStyles.tagsSection = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};

headerStyles.tagsTitle = {
    forwardAs: "p",
    transform: "capitalize",
    variant: "h6",
    css: css`
        margin-bottom: 0;
    `,
};

headerStyles.tagsWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
    `,
};

headerStyles.tag = {
    css: css`
        margin: 0;
        border-radius: 13px;
        padding: 4px 8px;
    `,
};

headerStyles.descriptionStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 8px;
            @media print {
                margin-bottom: 8px;
            }
        `,
    },
    heading: {
        forwardAs: "p",
        transform: "capitalize",
        variant: "h6",
        css: css`
            margin: 0;
        `,
    },
    text: {
        forwardAs: "p",
        size: 14,
        lineHeight: "22px",
    },
};

headerStyles.lastUpdateText = {
    as: "p",
    size: 14,
    color: "common.ui6",
    css: css`
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
    `,
};

headerStyles.totalLabel = {
    variant: "h6",
    as: "p",
    css: css`
        margin-bottom: 0;
    `,
};

headerStyles.totalText = {
    as: "p",
    variant: "h5",
    weight: fontConfig.weight.regular,
    css: css`
        margin-bottom: 0;
    `,
};

headerStyles.totalVatLabelText = {
    size: 12,
    css: css`
        margin-left: 5px;
    `,
};

headerStyles.totalWithoutVatText = {
    weight: fontConfig.weight.bold,
    css: css`
        margin-left: 5px;
    `,
};

headerStyles.totalWithoutVatLabelText = {
    size: 12,
    css: css`
        margin-left: 5px;
    `,
};

headerStyles.totalWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 7px;
    `,
};

headerStyles.addListTagsLink = {
    ...iconLinkCommonStyles(Plus),
};
